import axios from 'axios';
import {URLS} from './URL';
import {toast} from 'react-toastify';

export function showError(e) {
    let message = 'Something went wrong. Please try again';
    if (e.response && e.response.data.message) {
        message = e.response.data.message;
    } else if (!e.response) {
        message = 'Internet not available.'
    }
    toast(message, {type: 'error'})
}

export const login = (data) => {
    return axios.post(URLS.LOGIN, data);
};

export const requireSigning = (deviceName) => {
    return axios.get(URLS.REQUIRE_SIGNING + deviceName);
};

export const show = (id) => {
    return axios.get(URLS.SHOW + id);
};

export const saveSignature = (id, signature) => {
    return axios.post(URLS.SAVE_SIGNATURE + id, {signature})
};

export const markSigned = (id) => {
    return axios.post(URLS.MARK_SIGNED + id, {})
};

export const markCancel = (id) => {
    return axios.post(URLS.MARK_CANCELLED + id, {})
};

export const saveResponse = (response) => {
    const form = new FormData();
    form.append('response', response);
    return axios.post(URLS.RESPONSES, form)
};

export const getAdvertisements = () => {
    return axios.get(URLS.ADVERTISEMENTS)
};
